import React, { PureComponent } from 'react';
import './ClientTable.css';
import Fmt from './Fmt';
import {InlineTooltip, ContainerTooltip} from './Tooltip';
import * as _ from 'lodash';
import {Sparklines, SparklinesLine, SparklinesReferenceLine} from 'react-sparklines';

class ClientTable extends PureComponent {

    render() {
        console.log("ClientTable.render()");
        const rows = this.props.clientData.map(cd => {
            const key = cd.account.client_id;
            return <ClientTableRow clientData={cd} key={key} />
        });

        return (
            <div className="client-table-main">
                {rows}
            </div>
        );
    }
}

class ClientTableRow extends PureComponent {

    constructor(props) {
        super(props);

        this.state = {expanded: false};

        this.toggle = this.toggle.bind(this);
    }

    toggle() {
        this.setState(prevState => {
            return {expanded: !prevState.expanded};
        });
    }

    getVisitsBreakdown() {
        const touchpoints = _.chain(this.props.clientData.visits)
            .filter(item => item.name && item.name.toLowerCase() !== "all")
            .sortBy(item => item.name)
            .reverse()
            .sortBy(item => _.chain(item.weekly.raw_data).map(x => x.visits).sum().value())
            .reverse()
            .take(5);

        const sections = touchpoints.map(tp => {
            return (
                <div className="uniform-width" key={tp.name}>
                    <ColumnHeader title={tp.name} />
                    <TrendSection metric={tp.metric_key} timeSeries={tp.weekly} referenceValue={4602}/>
                </div>
            );
        }).value();

        return (
            <div className="uk-flex row">
                <div className="second-row-first-cell">
                    <span className="fa fa-close icon-active" onClick={this.toggle} />
                </div>
                {sections}
            </div>
        );
    }

    render() {
        const cd = this.props.clientData;

        const secondRow = this.state.expanded ? this.getVisitsBreakdown() : null;

        const visitsTitle = cd.visits.likely_api_consumer ? "Visits**" : "Visits";
        const visitsTooltip = cd.visits.likely_api_consumer ? "This client appears to consume the API. Click the Visits tile to see call volume." : null;

        return (
            <div>
                <div className="uk-flex row">
                    <AccountInfo clientData={cd} />
                    <div className="uk-flex">
                        <div className="uniform-width">
                            <ColumnHeader title="Score" />
                            <HealthScore score={cd.health_score} />
                        </div>
                        <div className="uniform-width">
                            <ColumnHeader title="Setup" />
                            <SetupTiles clientData={cd} />
                        </div>
                        <div className="uniform-width clickable" onClick={this.toggle}>
                            <ColumnHeader title={visitsTitle} tooltipText={visitsTooltip} />
                            {/* reference value based off of 20k visits per month (2.4M per year/365*7 for the weekly number) */}
                            <TrendSection metric="visits" timeSeries={cd.visits.all.weekly} referenceValue={4602}/>
                        </div>
                        <div className="uniform-width">
                            <ColumnHeader title="App Sessions" />
                            {/* reference values based off of 2 visits per day for 260 workdays */}
                            <TrendSection metric="sessions" timeSeries={cd.app_sessions.weekly} referenceValue={10} />
                        </div>
                        <div className="uniform-width">
                            <ColumnHeader title="Tagged Items" />
                            {/* reference values based off of 3 tags per day for 260 workdays */}
                            <TrendSection metric="items" timeSeries={cd.tagged_items.weekly} referenceValue={15} />
                        </div>
                    </div>
                </div>
                {secondRow}
            </div>
        );
    }
}

class AccountInfo extends PureComponent {

    render() {
        const d = this.props.clientData.account;

        return (
            <div className="account">
                <a href={d.account_link} className="account-title" target="_blank">{d.client_name}</a>
                <div>
                    <span className="nv-name">AM</span>
                    <span>{d.am}</span>
                </div>
                <div>
                    <span className="nv-name">ECom</span>
                    <span>{d.has_ecom ? "True" : "False"}</span>
                </div>
                <div>
                    <InlineTooltip text="Start Date" className="nv-name">
                        The contract start date of the earliest closed won opportunity that includes the client.
                    </InlineTooltip>
                    <span>{`${Fmt.dt(d.start_date)} (${Fmt.num(d.days_since_start)} days)`}</span>
                </div>
                { /* ARR-proration logic is currently inaccurate. */ }
                <div>
                    <InlineTooltip text="ARR Total" className="nv-name">
                        Total ARR is the sum value of open renewal opportunities that this client is associated with in Salesforce,
                        regardless of how many other clients are associated with the opportunity.
                    </InlineTooltip>
                    <span>{Fmt.num(d.arr_total)}</span>
                </div>
                <div>
                    <span className="nv-name">Renewal</span>
                    <a href={d.renewal_link} target="_blank">{Fmt.dt(d.renewal_date)}</a>
                </div>
                { /* We don't have consistent stages for renewals yet. Until we change that, hiding this property. */ }
                { /*
                <div>
                    <span className="nv-name">Stage</span>
                    <span>{d.renewal_stage}</span>
                </div>
                */ }
                {this.renderRed(d)}
                {this.renderParent(d)}
            </div>
        );
    }

    renderRed(d) {
        let el = null;
        if (d.is_red_account) {
            el = (
                <div>
                    <span className="nv-name">Red Trigger</span>
                    <InlineTooltip text={d.red_account_trigger}>{d.red_account_notes}</InlineTooltip>
                </div>
            );
        }

        return el;
    }


    renderParent(d) {
        let el = null;
        if (d.parent_id) {
            el = (
                <div>
                    <div>
                        <span className="nv-name">Parent</span>
                        <a href={d.parent_link} target="_blank">{d.parent_name}</a>
                    </div>
                </div>
            );
        }

        return el;
    }
}

class SetupTiles extends PureComponent {

    render() {
        const cd = this.props.clientData;

        const catalogClass = "score-background-" + cd.product_catalogs.score;
        const catalogMessage = cd.product_catalogs.score_message;

        const fanreelClass = "score-background-" + cd.visits.fanreel.score;
        const fanreelMessage = cd.visits.fanreel.score_message;

        const revenueClass = "score-background-" + cd.revenue_connections.score;
        const revenueMessage = cd.revenue_connections.score_message;

        const activeUserClass = "score-background-" + cd.active_users.score;
        const activeUserMessage = cd.active_users.score_message;

        return (
            <div className="setup">
                <div className={"tile-setup top left " + catalogClass}>
                    <InlineTooltip text="Product Catalog">{catalogMessage}</InlineTooltip>
                </div>
                <div className={"tile-setup top " + fanreelClass}>
                    <InlineTooltip text="Fanreel Onsite">{fanreelMessage}</InlineTooltip>
                </div>
                <div className={"tile-setup left " + revenueClass}>
                    <InlineTooltip text="Rev. Connected">{revenueMessage}</InlineTooltip>
                </div>
                <div className={"tile-setup " + activeUserClass}>
                    <InlineTooltip text="Active Users">{activeUserMessage}</InlineTooltip>
                </div>
            </div>
        );
    }
}

class HealthScore extends PureComponent {

    render() {

        const s = this.props.score;
        const overall = Math.round(s.score);
        const cls = "score-" + s.meta_score;

        const componentRows = s.components.map(c => {
            return (
                <tr key={c.name}>
                    <td>{c.name}</td>
                    <td>{Fmt.num(c.score, 1) + "/" + c.max}</td>
                </tr>
            );
        });

        return (
            <div>
                <div className="centered">
                    <span className={"health-score " + cls}>{overall}</span>
                </div>
                <table className="small-text block-centered">
                    <tbody>
                        {componentRows}
                    </tbody>
                </table>
            </div>
        );
    }
}

class TrendSection extends PureComponent {

    render() {

        const ts = this.props.timeSeries;
        const metricName = this.props.metric;

        const icon = ts.percentage_delta < 0 ? "fa-chevron-down" : "fa-chevron-up";
        const cls = "score-" + ts.score;
        const fourWeekIcon = ts.four_week_percentage_delta < 0 ? "fa-chevron-down" : "fa-chevron-up";
        const fourWeekCls = "score-" + ts.four_week_score;

        const dataPoints = _.chain(ts.raw_data).map(x => x[metricName]);
        const max = dataPoints.max().value();
        const last = dataPoints.last().value();

        const referenceValue = this.props.referenceValue;
        const chartMax = max > referenceValue ? max : Math.floor(referenceValue * 1.1);
        const chartMin = 0;
        const chartHeight = 80;
        const chartWidth = 180;
        const referenceLineColor = last >= referenceValue ? "limegreen" : "red";

        // the reference line functionalilty seems to have a bug in which the value is set from the *top* of the graph
        // by pixels, and not by the Y value.
        // Therefore, the correct value is the max value of the graph minus the value fo the reference line scaled
        // to the height of graph. We assume a y min of zero.
        // For example, if the max of the graph is 30,000, and you want reference line at 20,000, the correct value is
        // (30,000 - 20,000)/30,000 * chartHeight.
        const referenceValueForChart = (chartMax - referenceValue)/chartMax * chartHeight;

        const datapointText = _.map(ts.raw_data, d => `${Fmt.dt(d["date"])}: ${Fmt.num(d[metricName])}`).reverse().join("\n");
        const tooltipText = `Target minimum: ${Fmt.num(referenceValue)}\n${datapointText}`;

        return (
            <div>
                <div className="tile-height uk-flex centered">
                    <div className="uk-width-1-2">
                        <div className="smaller-text bold">Last 4 Weeks</div>
                        <div className="bigger-text">{Fmt.num(ts.four_week_current)}</div>
                        <div className={"bigger-text " + fourWeekCls}>
                            <span className={"fa " + fourWeekIcon} />
                            <span>{Fmt.num(ts.four_week_percentage_delta) + "%"}</span>
                        </div>
                    </div>
                    <div className="uk-width-1-2">
                        <div className="smaller-text bold">Last Week</div>
                        <div className="bigger-text">{Fmt.num(ts.current)}</div>
                        <div className={"bigger-text " + cls}>
                            <span className={"fa " + icon} />
                            <span>{Fmt.num(ts.percentage_delta) + "%"}</span>
                        </div>
                    </div>
                </div>
                <div className="tile-height">
                    <ContainerTooltip tooltipText={tooltipText}>
                        <Sparklines data={dataPoints.value()} width={chartWidth} height={chartHeight} min={chartMin} max={chartMax} margin={0} >
                            <SparklinesLine color="blue" />
                            <SparklinesReferenceLine type="custom" value={referenceValueForChart} style={{stroke: referenceLineColor, strokeOpacity: .75, strokeDasharray: '2, 2' }} />
                        </Sparklines>
                    </ContainerTooltip>
                </div>
            </div>

        );
    }
}

class ColumnHeader extends PureComponent {
    render() {
        const text = !this.props.tooltipText ? this.props.title :
            <InlineTooltip text={this.props.title}>
                {this.props.tooltipText}
            </InlineTooltip>

        return <div className="column-header">{text}</div>
    }
}

export default ClientTable;



// WEBPACK FOOTER //
// ./src/ClientTable.js